import { Add } from "@mui/icons-material";
import LockIcon from "@mui/icons-material/Lock";
import {
  Box,
  Dialog,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  Tooltip,
} from "@mui/material";
import { useDialog } from "common";
import { PrivateEventData } from "features/bookings/bookingApi";
import { BOOKING_STATUSES } from "features/bookings/bookingConstants";
import BookingForm from "features/bookings/BookingForm";
import I18n from "i18n";
import { useState } from "react";
import EventForm from "./EventForm";

export interface CreatePrivateEventButtonProps {
  afterSave?: () => void;
}

export default function CreatePrivateEventButton({
  afterSave,
}: CreatePrivateEventButtonProps) {
  const [isOpen, setIsOpen, dialogProps] = useDialog();
  const [step, setStep] = useState(0);
  const [eventData, setEventData] = useState<PrivateEventData | undefined>();

  function handleClose() {
    setIsOpen(false);
    setStep(0);
    setEventData(undefined);
  }

  function handleEventStepComplete(item: PrivateEventData) {
    setEventData(item);
    setStep(1);
  }

  function handleBookingSaved() {
    handleClose();
    afterSave?.();
  }

  const steps = [
    I18n.t("Event.privateCreate.step1"),
    I18n.t("Event.privateCreate.step2"),
  ];

  return (
    <>
      <Tooltip title={I18n.t("Event.privateCreate.buttonLabel")}>
        <IconButton onClick={() => setIsOpen(true)}>
          <LockIcon />
          <Add
            color="info"
            sx={{ position: "absolute", top: 2, right: 2, fontSize: "0.7em" }}
          />
        </IconButton>
      </Tooltip>
      <Dialog {...dialogProps} maxWidth="xl" fullWidth>
        {isOpen && (
          <>
            <Box sx={{ px: 3, pt: 2 }}>
              <Stepper activeStep={step}>
                {steps.map(label => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
            {step === 0 && (
              <EventForm
                defaultValues={
                  { private: true, status: BOOKING_STATUSES.ACTIVE } as any
                }
                hideBookingList
                onStepComplete={handleEventStepComplete}
                onClose={handleClose}
              />
            )}
            {step === 1 && eventData && (
              <BookingForm
                defaultValues={{ event: eventData } as any}
                createPrivateEventData={eventData}
                onClose={() => setStep(0)}
                afterSave={handleBookingSaved}
              />
            )}
          </>
        )}
      </Dialog>
    </>
  );
}
